import * as io from 'io-ts';

export enum CheckoutExperience {
  Ecomm = 'Ecomm',
  Clover = 'Clover',
  VirtualCard = 'VirtualCard',
  VirtualCardEcomm = 'VirtualCardEcomm',
}

export const CheckoutExperiences = io.union([
  io.literal(CheckoutExperience.Ecomm),
  io.literal(CheckoutExperience.Clover),
  io.literal(CheckoutExperience.VirtualCard),
  io.literal(CheckoutExperience.VirtualCardEcomm),
]);

export type CheckoutExperiences = io.TypeOf<typeof CheckoutExperiences>;
